import React from 'react';
import _ from 'lodash';
import { SgExperianService } from 'sg-capability-experian';
import { ModalNextProvider } from '@jutro/components';
import { publish } from '@jutro/events';
import {
    SgSubmissionUtil,
    ADOBE_TOPICS,
    SgSessionStorageService,
    SPM_TAGGING_PROPERTIES
} from 'saga-modules';
import SpmConstants from 'sg-spm-constants';
import SgCaisModalCtrl from 'sg-cais-modal';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { SG_AA_CAIS_DIRECTION } from '../sg-adobe-analytics/AdobeAnalyticsConstants';

const STEP_PREVIOUS = 'previous';
const STEP_NEXT = 'next';

function updateBindData(modelVM, updateData, response) {
    const newModelVM = _.clone(modelVM);
    newModelVM.bindData.value = response.bindData;
    if (_.isEmpty(SgSubmissionUtil.getMonthlyUpfrontPaymentPlan(newModelVM))) {
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.SELECTED_PAYMENT_ID, SgSubmissionUtil.getAnnualPaymentPlan(newModelVM).billingId);
    }
    updateData(newModelVM);
}

async function checkCais(modelVM, updateData) {
    return new Promise((resolve) => {
        SgExperianService.performCAISCheck(modelVM.value).then((response) => {
            updateBindData(modelVM, updateData, response);
            resolve(_.find(response.lobData.privateMotor.coverables.spmDrivers, (driver) => driver.isPolicyHolder).caischeckStatus);
        }).catch(() => {
            resolve(SpmConstants.CAIS_RESPONSE.FAILED_CHECK_SERVICE);
        });
    });
}

function recalculateToAnnual(direction, props) {
    const {
        modelVM, updateData, goNext
    } = props;
    const newModelVM = _.clone(modelVM);
    newModelVM.quoteData.offeredQuotes.value[0].requestedPaymentPlanId_Ext = SgSubmissionUtil.getAnnualPaymentPlan(newModelVM).billingId;
    LoadSaveService.saveAndQuoteSubmission(newModelVM).then((modelVMUpdate) => {
        updateData(modelVMUpdate);
        if (direction === STEP_NEXT) {
            publish(ADOBE_TOPICS.ADOBE_EVENT,
                { adobeID: SPM_TAGGING_PROPERTIES.caisModalInteraction, value: SG_AA_CAIS_DIRECTION.CONTINUE });
            goNext();
        } else {
            publish(ADOBE_TOPICS.ADOBE_EVENT,
                { adobeID: SPM_TAGGING_PROPERTIES.caisModalInteraction, value: SG_AA_CAIS_DIRECTION.BACK });
            props.goBack();
        }
    });
}

function handleCaisAdobe(response, modelVM) {
    let caisAAResponse = response;
    if (response === SpmConstants.CAIS_RESPONSE.ERROR) {
        if (!_.isEmpty(SgSubmissionUtil.getMonthlyUpfrontPaymentPlan(modelVM))) {
            caisAAResponse = SpmConstants.CAIS_RESPONSE.ERROR_ALLOWED_MONTHLY;
        } else {
            caisAAResponse = SpmConstants.CAIS_RESPONSE.ERROR_NOT_ALLOWED_MONTHLY;
        }
    }
    publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: SPM_TAGGING_PROPERTIES.caisResponse, value: caisAAResponse });
}

function handleCaisCheck(props) {
    const {
        modelVM, updateData, goNext
    } = props;
    checkCais(modelVM, updateData).then((response) => {
        handleCaisAdobe(response, modelVM);
        const phDriver = _.find(modelVM.lobData.privateMotor.coverables.spmDrivers.value, { isPolicyHolder: true });

        if (!phDriver.hasAcceptedCAISCheck) {
            recalculateToAnnual(STEP_PREVIOUS, props);
            return modelVM;
        }

        if (response === SpmConstants.CAIS_RESPONSE.PASSED_CHECK_SERVICE) {
            goNext();
        } else {
            const caisModalProps = {};

            switch (response) {
                case SpmConstants.CAIS_RESPONSE.ERROR:
                    if (!_.isEmpty(SgSubmissionUtil.getMonthlyUpfrontPaymentPlan(modelVM))) {
                        caisModalProps.response = SpmConstants.CAIS_RESPONSE.ERROR_ALLOWED_MONTHLY;
                        caisModalProps.onConfirm = goNext;
                        publish(ADOBE_TOPICS.ADOBE_EVENT,
                            { adobeID: SPM_TAGGING_PROPERTIES.caisModalInteraction, value: SG_AA_CAIS_DIRECTION.CONTINUE });
                    } else {
                        caisModalProps.response = SpmConstants.CAIS_RESPONSE.ERROR_NOT_ALLOWED_MONTHLY;
                        caisModalProps.onConfirm = (event) => recalculateToAnnual(STEP_NEXT, props, event);
                        caisModalProps.onCancel = (event) => recalculateToAnnual(STEP_PREVIOUS, props, event);
                    }
                    break;
                case SpmConstants.CAIS_RESPONSE.PASSED_CHECK_CACHE:
                    caisModalProps.response = SpmConstants.CAIS_RESPONSE.PASSED_CHECK_CACHE;
                    caisModalProps.onConfirm = goNext;
                    publish(ADOBE_TOPICS.ADOBE_EVENT,
                        { adobeID: SPM_TAGGING_PROPERTIES.caisModalInteraction, value: SG_AA_CAIS_DIRECTION.CONTINUE });
                    break;
                case SpmConstants.CAIS_RESPONSE.FAILED_CHECK_CACHE:
                    caisModalProps.response = SpmConstants.CAIS_RESPONSE.FAILED_CHECK_CACHE;
                    caisModalProps.onCancel = (event) => recalculateToAnnual(STEP_PREVIOUS, props, event);
                    break;
                case SpmConstants.CAIS_RESPONSE.FAILED_CHECK_SERVICE:
                    caisModalProps.response = SpmConstants.CAIS_RESPONSE.FAILED_CHECK_SERVICE;
                    caisModalProps.onConfirm = (event) => recalculateToAnnual(STEP_NEXT, props, event);
                    caisModalProps.onCancel = (event) => recalculateToAnnual(STEP_PREVIOUS, props, event);
                    break;
                default:
                    break;
            }
            return ModalNextProvider.showModal(<SgCaisModalCtrl {...caisModalProps} />);
        }
        return modelVM;
    });
}

export default {
    handleCaisCheck
};
